// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"SideInfo-module--info-wrapper--3_wPq","info":"SideInfo-module--info--26E-p","heading":"SideInfo-module--heading--1T1YT","detail":"SideInfo-module--detail--DiSJC"};